import { SmartTagDefault } from './smartTagDefault';
import { SmartTagAsset, SmartTagAssetModel } from './smartTagAsset';
import { SmartTagUpdate, SmartTagUpdateModel } from './smartTagUpdate';
import { SmartTagView, SmartTagViewModel } from './smartTagView';
import { SmartTagScanComments } from './smartTagScanComments';
import { SmartTagRoad, SmartTagRoadModel } from './smartTagRoad';
import { SmartTagPool, SmartTagPoolModel } from './smartTagPool';
import { SmartTagConvertedGarage, SmartTagConvertedGarageModel } from './smartTagConvertedGarage';
import { SmartTagDeficiency, SmartTagDeficiencyModel } from './smartTagDeficiency';
import { SmartTagCompromise, SmartTagCompromiseModel } from './smartTagCompromise';
import { SmartTagFeatures, SmartTagFeaturesModel } from './smartTagFeatures';
import { SmartTagWindows, SmartTagWindowsModel } from './smartTagWindows';
import { SmartTagPoolType } from './smartTagPoolType';
import { SmartTagMaterials, SmartTagMaterialsModel } from './smartTagMaterials';
import { SmartTagSurface, SmartTagSurfaceModel } from './smartTagSurface';
import { SmartTagSpace, SmartTagSpaceModel } from './smartTagSpace';
import { SmartTagUpdateType, SmartTagUpdateTypeModel } from './smartTagUpdateType';
import { SmartTagFence, SmartTagFenceModel } from './smartTagFence';
import { SmartTagFormRenderEngine, SmartTagFormRenderEngineModel } from './smart-tag-render-form-engine.model';

export const RENDERERS = {
	// Legacy
	'Asset': SmartTagAsset,
	'FEATURE_INTERIOR': SmartTagDefault,
	'UPDATE_INTERIOR_WALL_WINDOW_DOORS': SmartTagUpdate,
	'UPDATE_INTERIOR_FLOORS': SmartTagUpdate,
	'UPDATE_INTERIOR_CABINET_COUNTERTOPS': SmartTagUpdate,
	'UPDATE_INTERIOR_PLUMBUNG': SmartTagUpdate,
	'UPDATE_EXTERIOR_SIDING_ROOF': SmartTagUpdate,
	'UPDATE_EXTERIOR_WINDOWS_DOORS': SmartTagUpdate,
	'UPDATE_EXTERIOR_MECHANICAL': SmartTagUpdate,
	'UPDATE_INTERIOR_ELECTRICAL': SmartTagUpdate,
	'CONDITION_OBSERVATION_INTERIOR_FLOOR': SmartTagDefault,
	'CONDITION_OBSERVATION_INTERIOR_WALL': SmartTagDefault,
	'CONDITION_OBSERVATION_INTERIOR_CEILING': SmartTagDefault,
	'CONDITION_OBSERVATION_WINDOW': SmartTagDefault,
	'CONDITION_OBSERVATION_INTERIOR_PLUMBING': SmartTagDefault,
	'CONDITION_OBSERVATION_ELECTRICAL': SmartTagDefault,
	'CONDITION_OBSERVATION_INTERIOR_HVAC': SmartTagDefault,
	'CONDITION_OBSERVATION_EXTERIOR_SIDING': SmartTagDefault,
	'CONDITION_OBSERVATION_EXTERIOR_ROOF': SmartTagDefault,
	'CONDITION_OBSERVATION_EXTERIOR_FOUNDATION': SmartTagDefault,
	'CONDITION_OBSERVATION_EXTERIOR_PLUMBING': SmartTagDefault,
	'CONDITION_OBSERVATION_EXTERIOR_HVAC': SmartTagDefault,
	'CONDITION_OBSERVATION_INTERIOR_APPLIANCE': SmartTagDefault, //
	'CONDITION_OBSERVATION_INTERIOR_OTHER': SmartTagDefault,
	'CONDITION_OBSERVATION_SITE': SmartTagDefault,
	'CONDITION_OBSERVATION_EXTERIOR_OTHER': SmartTagDefault,
	'FEATURE_EXTERIOR_YARD': SmartTagDefault,
	'FEATURE_EXTERIOR_OUTDOOR_LIVING': SmartTagDefault,
	'FEATURE_EXTERIOR_WATER': SmartTagDefault,
	'PARKING_EXTERIOR': SmartTagView,
	'VIEW_BACK': SmartTagView, // New
	'VIEW_WATER': SmartTagView,
	'VIEW_FRONT': SmartTagView, // New
	'VIEW_LANDSCAPE': SmartTagView,
	'VIEW_LEFT_SIDE': SmartTagView, // New
	'VIEW_RIGHT_SIDE': SmartTagView, // New
	'VIEW_NEIGHBORHOOD': SmartTagView,
	'VIEW_UTILITIES': SmartTagView,
	'VIEW_OTHER': SmartTagView,
	'Scan Comment': SmartTagScanComments,
	// Custom
	'TagDefault': SmartTagDefault,
	'TagAsset': SmartTagAsset,
	'TagUpdate': SmartTagUpdate,
	'TagView': SmartTagView,
	'TagIngroundPool': SmartTagPool,
	'TagRoad': SmartTagRoad,
	'TagConvertedGarage': SmartTagConvertedGarage,
	// New Smart Tags
	'TagDeficiency': SmartTagDeficiency,
	'TagCompromise': SmartTagCompromise,
	'TagFeatures': SmartTagFeatures,
	'TagWindows': SmartTagWindows,
	'TagPoolType': SmartTagPoolType,
	'TagMaterials': SmartTagMaterials,
	'TagSurface': SmartTagSurface,
	'TagSpace': SmartTagSpace,
	'TagUpdateType': SmartTagUpdateType,
	'TagFence': SmartTagFence,
	'TagFormRender': SmartTagFormRenderEngine,
};

export const SmartTagTemplateModelClass = {
	'TagAsset': SmartTagAssetModel,
	'TagUpdate': SmartTagUpdateModel,
	'TagView': SmartTagViewModel,
	'TagIngroundPool': SmartTagPoolModel,
	'TagRoad': SmartTagRoadModel,
	'TagConvertedGarage': SmartTagConvertedGarageModel,
	// New Smart Tags
	'TagDeficiency': SmartTagDeficiencyModel,
	'TagCompromise': SmartTagCompromiseModel,
	'TagFeatures': SmartTagFeaturesModel,
	'TagWindows': SmartTagWindowsModel,
	'TagPoolType': SmartTagPoolModel,
	'TagMaterials': SmartTagMaterialsModel,
	'TagSurface': SmartTagSurfaceModel,
	'TagSpace': SmartTagSpaceModel,
	'TagUpdateType': SmartTagUpdateTypeModel,
	'TagFence': SmartTagFenceModel,
	'TagFormRender': SmartTagFormRenderEngineModel,
}
